import { useEffect, useState } from 'react';
import './FlowerBloomPopup.css';

interface FlowerBloomPopupProps {
  isVisible: boolean;
  onClose: () => void;
  flowerCount: number;
}

export default function FlowerBloomPopup({ isVisible, onClose, flowerCount }: FlowerBloomPopupProps) {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      // 少し遅延してアニメーション開始
      setTimeout(() => setIsAnimating(true), 100);
      
      // 5秒後にフェードアウト開始
      const fadeTimer = setTimeout(() => {
        setIsAnimating(false);
      }, 5000);

      // フェードアウト完了後にコンポーネントを非表示
      const hideTimer = setTimeout(() => {
        setShouldRender(false);
        onClose();
      }, 5500);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(hideTimer);
      };
    } else {
      // フェードアウト開始
      setIsAnimating(false);

      // フェードアウト完了後にコンポーネントを非表示
      setTimeout(() => {
        setShouldRender(false);
        onClose();
      }, 500);
    }
  }, [isVisible, onClose]);

  if (!shouldRender) return null;

  return (
    <div
      className={`flower-popup-overlay ${isAnimating ? 'visible' : ''}`}
      onClick={onClose}
    >
      <div
        className="flower-popup-content"
        onClick={(e) => e.stopPropagation()}
      >
      <div className="popup-message">
        <h2 className="popup-title">スタンプを押しました！</h2>
        <p className="popup-subtitle">{flowerCount}個目のスタンプです</p>
      </div>

      <div className="popup-flower-container">
        <img
          src="/water.gif"
          alt="水やりアニメーション"
          className="water-animation"
        />
      </div>

      <div className="popup-progress">
        <p className="progress-message">
          あと{100 - flowerCount}個で目標達成！
        </p>
        </div>
      </div>
    </div>
  );
}